import { englishNumber } from './number';

const arabicList = [
  'أ',
  'ؤ',
  'إ',
  'ا',
  'ڪ',
  'ة',
  'ۓ',
  'ە',
  'ك',
  'ي',
  'ٵ',
  'ٷ',
  'ٸ',
  'ﭕ',
  'ﭙ',
  'ﭽ',
  'ﮋ',
  'ﮑ',
  'ﮕ',
  'ﮭ',
  'ﮱ',
  'ﯣ',
  'ﯧ',
  'ﯿ',
  'ﴽ',
  'ﯿ',
  'ﺁ',
  'ﺂ',
  'ﺄ',
  'ﺈ',
  'ﺌ',
  'ﺎ',
  'ﺒ',
  'ﺔ',
  'ﺘ',
  'ﺜ',
  'ﺠ',
  'ﺤ',
  'ﺨ',
  'ﺪ',
  'ﺬ',
  'ﺮ',
  'ﺰ',
  'ﺴ',
  'ﺸ',
  'ﺼ',
  'ﻀ',
  'ﻄ',
  'ﻈ',
  'ﻌ',
  'ﻐ',
  'ﻘ',
  'ﻜ',
  'ﻠ',
  'ﻤ',
  'ﻨ',
  'ﻮ',
  'ﻴ',
  'ﻼ',
];

const persianList = [
  'ا',
  'و',
  'ا',
  'ا',
  'ک',
  'ه',
  'ی',
  'ه',
  'ک',
  'ی',
  'ا',
  'و',
  'ی',
  'ی',
  'پ',
  'چ',
  'ژ',
  'ک',
  'گ',
  'ه',
  'ی',
  'و',
  'ی',
  'ی',
  'ا',
  'ی',
  'ا',
  'ا',
  'ا',
  'ا',
  'ی',
  'ا',
  'ب',
  'ه',
  'ت',
  'ث',
  'ج',
  'ح',
  'خ',
  'د',
  'ذ',
  'ر',
  'ز',
  'س',
  'ش',
  'ص',
  'ض',
  'ط',
  'ظ',
  'ع',
  'غ',
  'ق',
  'ک',
  'ل',
  'م',
  'ن',
  'و',
  'ی',
  'لا',
];

export const ARABIC_TO_PERSIAN_MAP = Object.fromEntries(
  arabicList.map((char, i) => [char, persianList[i]])
);

export const normalizeArabicToPersian = (text: string) => {
  if (!text) return '';

  return text
    .split('')
    .map((ch: string) => ARABIC_TO_PERSIAN_MAP?.[ch] || ch)
    .join('');
};

export const truncate = (str: string, charNum: number = 50): string => {
  if (str.length > charNum) {
    const truncated = str.substring(0, charNum);
    return truncated.trim() + '...';
  }
  return str;
};

export const replaceAllApartLinks = (str: string): string => {
  const regex = /<a href="https:\/\/www?\.aparat.com\/v\/([^\s,^?]*)/gm;
  let m;
  const videoIdList: string[] = [];
  while ((m = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    videoIdList.push(m[1]);
  }

  let newStr = str;
  videoIdList.forEach((id) => {
    const videoId = id.substring(0, id.length - 1);
    /* eslint-disable */
    const str = `<a href="https:\/\/www?\.aparat.com\/v\/${id}.*<\/a>`;
    const singleItemPattern = new RegExp(str, 'g');
    const embedVideo = `<style>.h_iframe-aparat_embed_frame{position:relative;}.h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto;}.h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%;}</style><div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span><iframe src="https://www.aparat.com/video/video/embed/videohash/${videoId}/vt/frame" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe></div>`;
    newStr = newStr.replace(singleItemPattern, embedVideo);
  });
  return newStr;
};

export function isBlank(str: string) {
  return !str || str.match(/^ *$/) !== null;
}

export function generateRandomString(length: number) {
  let result = '';
  let characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export const smartNumericCompare = (aa: string, bb: string) => {
  if (!aa) return 1;
  if (!bb) return -1;
  const a = aa.replace(/^[^\p{L}\p{N}]+/u, '');
  const b = bb.replace(/^[^\p{L}\p{N}]+/u, '');
  let i = 0;
  while (i < a.length && i < b.length && a[i] === b[i]) i++;
  const commonPrefix = a.substring(0, i);

  const aNumber = parseInt(englishNumber(a.replace(commonPrefix, '')), 10);
  const bNumber = parseInt(englishNumber(b.replace(commonPrefix, '')), 10);

  if (!isNaN(aNumber) && !isNaN(bNumber)) {
    return aNumber - bNumber;
  }

  return a.localeCompare(b);
};
